<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import UiStatusPill from '@/Components/UI/UiStatusPill.vue'

const props = defineProps({ status: { type: String, required: true } })
const { t } = useI18n()

const MAP = {
  none: { tone: 'warn', icon: 'alert' },
  partial: { tone: 'warn', icon: 'alert' },
  paid: { tone: 'ok', icon: 'check' },
}

const cfg = computed(() => MAP[props.status] || MAP.none)
const label = computed(() => t(`rental.show.fields.depositPill.${props.status}`))
</script>

<template>
  <UiStatusPill
    v-if="status !== 'none'"
    :tone="cfg.tone"
    variant="soft"
    :icon="cfg.icon"
    :label="label"
  />
</template>
